// extracted by mini-css-extract-plugin
export var fadeInOut = "_3b-3";
export var icon = "_3b-4";
export var savedIndicator = "_3b-2";
export var savingIndicator = "_3b-0";
export var spin = "_3b-1";